import { Component } from '@angular/core';
import { NavbarComponent } from "../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-xnex',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './xnex.component.html',
  styleUrl: './xnex.component.css'
})
export class XnexComponent {
  currentImage: string = 'src/assets/img/xnex_page/684fff0c50e2adb9bd0f9f51_Xnex-30-ombra-p-2600.webp';

  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().xnex_page;
    this.title.setTitle('PRINX - XNEX Sport EV');
    if (typeof document !== 'undefined') {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', `${this.texts.hero.description}`);
      }
    }
  }

  imageSource(source: string): void {
    this.currentImage = source;
  }

  openUrlInNewTab(url: string): void {
    window.open(url, '_blank');
  }
}
